//
//	DS Carousel - config
//
var omniIotCarousel = tns({
	"container": ".omni-iot-carousel",
	"controlsContainer": ".omni-iot-carousel-controls",
	"preventScrollOnTouch": "auto",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"fixedWidth": 304,
	"slideBy": 1,
	"responsive": {
		"576": {
			"center": true
		},
		"768": {
			"items": 2,
			"slideBy": 2,
			"center": false
		}
	}
});



//
//	DOM ready
//
(function () {
	'use strict';

	var $ = avm.require('cash'),
		isCookieEnabled = avm.require('avast.storage.isCookieEnabled'),
		$awardBanner = $('.js-award-banner'),
		$awardBannerToggler = $awardBanner.find('.award-banner__toggler'),
		awardBannerVisibilityClass = 'js-award-banner--is-visible',
		awardBannerCookieName = 'AwardBannerCookieName',
		waypoints = avm.require('avast.web.waypoints'),
		$iotFeature = $('.js-iot-feature'),
		iotAnimationTriggerClass = 'js-showline',
		$tablesTooltip = $('.tables__tooltip');



	// returns "-1" if cookie with name
	// "AwardBannerCookieName" does NOT exists
	// (user did not hide the banner by clicking "X" button)
	function wasBannerClosed() {
		return document.cookie.indexOf(awardBannerCookieName);
	}


	//
	//  Show Award banner
	//
	function showAwardBanner() {
		if (isCookieEnabled) {
			if (wasBannerClosed() === -1) {
				$awardBanner.addClass(awardBannerVisibilityClass);

				$awardBannerToggler.on('click', function () {
					hideAwardBanner();
				});


				//
				//	hide Banner when reaches "Before The Footer" section
				//
				$(window).on('resize scroll', function () {
					if (wasBannerClosed() === -1) {
						if (waypoints($('.bft'), 0.80)) {
							$awardBanner.removeClass(awardBannerVisibilityClass);
						}
						else {
							$awardBanner.addClass(awardBannerVisibilityClass);
						}
					}
				});
			}
		}
	}


	//
	//  hide Award banner
	//
	function hideAwardBanner() {
		$awardBanner.removeClass(awardBannerVisibilityClass);

		// store cookie - remember that user closed the banner
		// so do not show it again (on page refresh or next visit)
		document.cookie = awardBannerCookieName + "=closed by user; expires=Wed, 21 Sep 2033 12:22:22 UTC; path=/";
	}




	////////////////////////////////
	//
	//  Initialize functions
	//
	////////////////////////////////
	showAwardBanner();



	//
	//  Tabs below hero - add active Tab id as a class for styling purposes
	//
	$('#tabs .nav-link').on('click',function(){
		var activeTabId = $(this).attr('id'),
			splitId = activeTabId.split('-');	// split string to get only active tab ID
			activeTabId = splitId[1];

		$('#tabs').attr( 'class', activeTabId);
	});




	//
	//  Change visual on Tab:click
	//
	$('#protection .nav-tabs a').on('click',function(){
		var tabContentId = $(this).closest('.nav-link').attr('aria-controls');
		var imageSrc = $('#' + tabContentId + ' .protection-image__src').attr('src');
		$('#protection .media-image img').attr('src', imageSrc);
	});




	//
	//	IOT animation handler
	//
	$iotFeature.on('click', function(){
		var _this = $(this);

		_this.toggleClass('active');


		if( _this.hasClass('feature-1') ) {
			$('#line-1').toggleClass(iotAnimationTriggerClass);
		}
		else if( _this.hasClass('feature-2') ) {
			$('#line-2').toggleClass(iotAnimationTriggerClass);
		}
		else if( _this.hasClass('feature-3') ) {
			$('#line-3').toggleClass(iotAnimationTriggerClass);
		}
		else if( _this.hasClass('feature-4') ) {
			$('#line-4').toggleClass(iotAnimationTriggerClass);
		}
	});




	//
	//	Keyboard accessible Tooltips - show tooltip when focused
	//
	$tablesTooltip.on('focus', function(e){
		$( this ).trigger('mouseenter');
	}).on('blur', function(e){
		$( this ).trigger('mouseleave');
	});


	//
	//	Blogspot articles slider
	//
	var slider = tns({
		"container": ".slider-articlesDefault",
		"controlsContainer": ".slider-articlesDefault-controls",
		"controlsPosition": "bottom",
		"preventScrollOnTouch": "auto",
		"controls": false,
		"navPosition": "bottom",
		"nav": true,
		"mouseDrag": true,
		"speed": 400,
		"loop": false,
		"fixedWidth": 276,
		"slideBy": 1,
		"responsive": {
			"992": {
				"mouseDrag": false,
				"controls": true
			},
			"1280": {
				"fixedWidth": 316
			}
		}
	});
})();
